import axios from 'axios';
import Cookies from 'js-cookie';
import { rememberReturnPath } from './utils/returnUrl';
import { reset as resetAnalytics } from './utils/analytics';

/**
 * Registers a global Axios response interceptor.
 * When the server returns 401 with { session_expired: true },
 * all cookies are cleared and the user is redirected to /login.
 *
 * Call once at app startup (e.g. in index.js or App.js).
 */
export function setupAxiosInterceptors() {
    // Ensure session cookie is sent with every request — no more per-call withCredentials
    axios.defaults.withCredentials = true;

    let isRedirecting = false;

    axios.interceptors.response.use(
        (response) => response,
        (error) => {
            const data = error?.response?.data;
            if (error?.response?.status === 401 && data?.session_expired === true && !isRedirecting) {
                isRedirecting = true;

                // Clear all auth cookies
                const cookiesToClear = [
                    'shop', 'shop_name', 'stores', 'allowed_pages_json',
                    'show_under_dev_pages', 'user_email', 'user_role',
                    'user_permissions', 'needs_store_setup', 'dev_page_permissions_by_store',
                ];
                cookiesToClear.forEach((name) => Cookies.remove(name, {
                    secure: process.env.REACT_APP_WENV !== "local",
                    domain: process.env.REACT_APP_WENV !== "local" ? ".cognitiveux.ai" : "",
                    path: "/",
                }));

                // The person is gone with the cookies — detach the analytics
                // identity so the next login doesn't merge into this profile.
                resetAnalytics();

                // Redirect to login (full reload to reset React state)
                // Skip if already on login/signup to avoid redirect loops
                const path = window.location.pathname;
                if (path !== '/login' && path !== '/signup') {
                    // Remember where they were headed so login can return them.
                    // Deep links mailed to a lapsed session (digest feedback
                    // links) would otherwise always land on the dashboard home.
                    rememberReturnPath(path + window.location.search);
                    window.location.href = '/login';
                }
            }
            return Promise.reject(error);
        }
    );
}